<template>
  <div>
    <h6>Valve Config Upload</h6>
    <b-form-file accept=".xls, .xlsx" v-model="file" placeholder="Choose config excel file (.xlsx) ..."></b-form-file>
    <div class="text-muted ">Not sure what to upload? Please, check config file sample: <b-button @click="sample" variant="link" style="background: none">here</b-button></div>
    <div v-if="file">
      <b-row class="mt-1">
        <b-col sm="3">
          <label for="config_sheet_name_inp">Valve sheet name:</label>
        </b-col>
        <b-col sm="9">
          <b-form-select id="config_sheet_name_inp" size="sm" type="text" v-model="config_sheet_name" :options="sheets" placeholder="Please, select sheet with config data">
          </b-form-select>
        </b-col>
      </b-row>

      <div v-if="errorMs.length" class="text-danger">
        <div v-for="e in errorMs">
          {{e}}
        </div>
      </div>
      <loading-overlay :show="loading"></loading-overlay>
    </div>
    <div class="upload-check-container" v-if="file">

      <b-button :disabled="!config_sheet_name" type="submit" variant="primary" @click="upload">Upload Valve config</b-button>
    </div>

  </div>
</template>
<script>

  import XLSX from 'xlsx'
  import LoadingOverlay from '../../LoadingOverlay'

  export default {
    components: {LoadingOverlay},
    created () {
      this.workbook = null
    },
    data () {
      return {
        file: null,
        config_sheet_name: null,
        sheets: [],
        valve_config_data: {},
        loading: false,
        errorMs: []
      }
    },
    computed: {},
    watch: {
      config_sheet_name (val) {
        let XL_row_object = XLSX.utils.sheet_to_row_object_array(this.workbook.Sheets[val], { raw: false })
        this.valve_config_data['config'] = this.extract_config_data(XL_row_object)
        this.valve_config_data['config']['table_name'] = val.toLowerCase().replace(/\W+/g, '_')
        this.validate_config(this.valve_config_data['config'], val, XL_row_object)
      },
      file (f) {
        if (!f) {
          return
        }
        let reader = new FileReader();

        this.errorMs = []
        this.sheets = []
        this.config_sheet_name = null
        this.valve_config_data = {}

        let me = this;
        this.loading = true

        reader.onload = function(e) {
          let data = reader.result;
          let workbook = XLSX.read(data, {
            type: 'binary',
            cellDates: true,
            dateNF: 'mm/dd/yyyy',
          });

          me.workbook = workbook

          me.sheets.push.apply(me.sheets, workbook.SheetNames.map(s => {
            return {
              text: s,
              value: s
            }
          }))

          me.loading = false

        };

        reader.onerror = function(ex) {
          console.log(ex);
          me.loading = false
        };

        reader.readAsBinaryString(f);
      }
    },
    methods: {
      sample () {
        let url = '/static/valve_config_sample.xlsx'
        let win = window.open(url, '_blank')
        win.focus()
      },
      validate_config (pack, sheet_name, raw) {
        // TODO set this up as part of qa
        if (!raw[0].hasOwnProperty('centreline_idents')) {
          this.errorMs.push(`${sheet_name} doesn't contain centreline_idents column. \n`)
        }

        if (!sheet_name.startsWith('valve_config')) {
          this.errorMs.push(`worksheet ${sheet_name} needs to start with the word valve_config. \n`)
        }
      },
      extract_config_data (data) {
        let columns = ['config_name']
        let config_names = []
        let types = ['string']
        let datum = []

        if (data.length) {
          data.forEach(d => {
            columns.push(d.centreline_idents)
            types.push('string')
          })
          config_names = Object.keys(data[0])
          config_names.splice(0,1)
        }

        return {
          columns: columns,
          config_names: config_names,
          data: data,
          types: types
        }

      },
      upload () {
        let fn = () => {
          this.loading = true
          let user = this.$store.getters['user/user']

          this.$http.post('/api/admin-board/import-valve-config/', {
            'data': this.valve_config_data,
            'workpack_id': this.$store.getters['project/currentProject'].workpack.id
          })
            .then(res=> {
              this.$notify({
                title: 'SUCCESS',
                text: 'valve config upload successful',
                type: 'success'
              })
              this.loading = false
              this.sheets.splice(0, this.sheets.length)
              this.valve_config_data = {}
              this.file = null
            }, e => {
              this.$notify({
                title: 'ERROR',
                text: 'Could not upload valve config',
                type: 'error'
              })
              this.loading = false
            })
        }

        if (this.errorMs.length) {
          if (confirm('Data is not valid. Please confirm upload.')) {
            fn()
          }
        } else {
          fn()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/admin/ValveConfigUpload.vue